import { createVanIconComponent } from "./van"

const OrdersOutlined = createVanIconComponent("orders-o")
export default OrdersOutlined
